import React, {useEffect} from 'react'
import {useApolloQuery as useQuery} from 'apollo-hooks'

import verifiedUser, {SpoonityValidUser} from './query/verifiedUser'
import Form from './Form'

export default function Login({preferences, activeLoyalty, setPreferences}) {
  const {loyaltyProgram} = preferences

  const {spoonityValidUser}: {spoonityValidUser: SpoonityValidUser} = useQuery({
    query: verifiedUser,
    variables: {
      sessionKey: loyaltyProgram?.sessionKey ?? ''
    },
    omit: !loyaltyProgram?.sessionKey
  })

  useEffect(() => {
    //Case wallet fails
    if (!spoonityValidUser && preferences.loyaltyProgram) {
      setPreferences({loyaltyProgram: null})
    }
  }, [spoonityValidUser])

  return (
    <>
      <Form
        email={preferences.user.email}
        activeLoyalty={activeLoyalty}
        isUserLoggedIn={preferences?.loyaltyProgram?.sessionKey}
      />
    </>
  )
}
